import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { CountryCode } from '@sigma/common/i18n/CountryCode.js';
import { Gender } from '@sigma/common/models/Gender.js';
import { PatientDataType } from '@sigma/common/patient/PatientDataType.js';
import { DateISO } from '@sigma/common/schema/DateISO.js';
import { recordSchema } from '@sigma/common/schema/recordSchema.js';
export const ProfileUpdateEndpointParams = z.object({
    firstName: z.string().check(z.minLength(1)),
    lastName: z.string().check(z.minLength(1)),
    birthDate: DateISO,
    gender: Gender,
    address: z.object({
        country: CountryCode,
        city: z.string().check(z.minLength(1)),
        street: z.string().check(z.minLength(1)),
        postCode: z.string().check(z.minLength(1)),
        state: z.nullish(z.string()),
    }),
    data: recordSchema(PatientDataType.options, z.nullish(z.string())),
});
/**
 * Endpoint for updating patient profile data.
 * Validates that either PESEL is provided OR both birth date and gender are provided.
 */
export const ProfileUpdateEndpoint = defineEndpoint({
    name: 'ProfileUpdateCommand',
    input: ProfileUpdateEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=ProfileUpdateEndpoint.js.map